import gql from 'graphql-tag'

export const GET_PRESET_CATEGORY_LIST = gql`
  query GetPresetCategories {
    presetCategories(orderBy: order_ASC) {
      id
      name
      presets {
        id
        name
        cover {
          id
          url
        }
        presetGroups {
          id
          name
        }
      }
    }
    presetGroups(orderBy: order_ASC) {
      id
      name
    }
  }
`

export const GET_PRESET_CATEGORY_BY_ID = gql`
  query GetPresetCategoryById($id: Int!) {
    presetCategory(id: $id) {
      id
      name
    }
  }
`



// WEBPACK FOOTER //
// ./src/graphql/queries/PresetCategory.js